import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/chevron-down.svg'
import _imports_1 from '@/assets/chevron-up.svg'


const _hoisted_1 = ["id"]
const _hoisted_2 = ["data-bs-target", "aria-controls"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["alt"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "collapse",
      id: _ctx.id
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 8, _hoisted_1),
    _createElementVNode("div", {
      class: "collapsible clickable collapsed",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
      "data-bs-toggle": "collapse",
      "data-bs-target": '#' + _ctx.id,
      "aria-expanded": "false",
      "aria-controls": _ctx.id
    }, [
      (_ctx.collapsed)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.textCollapsed) + " ", 1),
            _createElementVNode("img", {
              class: "chevron-down",
              src: _imports_0,
              alt: _ctx.textCollapsed
            }, null, 8, _hoisted_4)
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.textOpen) + " ", 1),
            _createElementVNode("img", {
              class: "chevron-up",
              src: _imports_1,
              alt: _ctx.textOpen
            }, null, 8, _hoisted_6)
          ]))
    ], 8, _hoisted_2)
  ], 64))
}